// CD 30% クランプ。ADR 0014 §2.5 / ADR 0003 §2.3.3 拡張 / 軸 6 §6.2。
//
// アルティ向けに ADR 0003 §2.3.3 で pin された「CD 短縮上限 30%」を、本 ADR で
// **全 active (アルティ含む)** に統一適用する。
//
// `final_cdr = min(0.30, affix + axis6 + other)`
//
// - `affix`: 4.5 `cooldownRateMod` アフィックス合計
// - `axis6`: 軸 6 archetype 4 (`cooldown-reduction`) スキル合計 (catalogue ADR 0015 で投入)
// - `other`: 将来拡張枠 (現状 0)
//
// 本 PR は数値計算 helper のみ提供。実 catalogue の `cooldown-reduction` 系統は
// ADR 0015 で投入されるため、本 PR の sim では layer 取得アダプタはまだ呼ばれない。
// tick.ts:230 の `tick + skill.cooldownTicks` 計算に組み込むのは ADR 0015 / Phase 4
// のチューニング段階で行う。
/** Hard cap for total cooldown-rate reduction. ADR 0003 §2.3.3。 */
export const COOLDOWN_RATE_MOD_CAP = 0.3;
/**
 * Resolve the final cooldown-rate reduction in [0, 0.30].
 *
 * - 合計が負 → 0
 * - 合計が 0.30 超 → 0.30
 * - それ以外 → 合計値そのまま
 *
 * 浮動小数誤差は呼び出し側で吸収済前提 (各 layer は %値 / 100 で渡される)。
 */
export function resolveCooldownRateMod(layers) {
    const sum = layers.affix + layers.axis6 + layers.other;
    if (sum <= 0)
        return 0;
    if (sum >= COOLDOWN_RATE_MOD_CAP)
        return COOLDOWN_RATE_MOD_CAP;
    return sum;
}
/**
 * Apply the CD clamp to a base cooldown duration in ticks. Returns the
 * cooldown after reduction (rounded to integer ticks).
 *
 * `effective = baseTicks × (1 - resolveCooldownRateMod(layers))`
 *
 * 端数処理: `Math.round` (0.5 tick 単位の偶発的下振れを抑制)。
 * `effective < 1` の場合は最小 1 tick (CD 完全消去は禁止)。
 */
export function applyCooldownRateMod(baseTicks, layers) {
    const cdr = resolveCooldownRateMod(layers);
    const effective = Math.round(baseTicks * (1 - cdr));
    return Math.max(1, effective);
}
//# sourceMappingURL=cd-clamp.js.map